<template>
  <div
    class="viewport-calc"
    ref="refRoot"
  />
</template>

<script setup lang="ts">
const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const update = () => {
  browser.setLargeViewportSize(
    refRoot.value.clientWidth,
    refRoot.value.clientHeight
  )
}
onMounted(update)
useResize(update)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.viewport-calc {
  // @include srOnly();
  position: fixed;
  top: 0;
  left: 0;
  width: 100lvw;
  height: 100lvh;
  pointer-events: none;
}
</style>
